import { __awaiter, __generator } from "tslib";
import { initializeWithAmplitudeAnalytics, } from '@amplitude/experiment-js-client';
var ExperimentPlugin = /** @class */ (function () {
    function ExperimentPlugin(config) {
        this.name = ExperimentPlugin.pluginName;
        this.config = config;
    }
    ExperimentPlugin.prototype.setup = function (config, _client) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.experiment = initializeWithAmplitudeAnalytics(config.apiKey, this.config);
                return [2 /*return*/];
            });
        });
    };
    ExperimentPlugin.pluginName = '@amplitude/experiment-analytics-plugin';
    return ExperimentPlugin;
}());
export { ExperimentPlugin };
export var experimentPlugin = function (config) {
    return new ExperimentPlugin(config);
};
//# sourceMappingURL=experiment.js.map